<template>
  <div class="form-input-simple">
    <el-col
       v-if="willBeCalculated"
      :span="6" class="el-col--min-14em">
      <el-input
         v-show="willBeCalculated"
        :placeholder="$t('label.will_be_calculated')"
        :disabled="true">
      </el-input>
    </el-col>
    <el-col
      v-else
      :span="6" class="el-col--min-14em">
      <el-input-number
         v-model="simple.value"
         class="w-100"
        :step="1"
        :min="validation.min"
        :max="validation.max"
        :disabled="disabled || dependent"
        @change="update">
      </el-input-number>
    </el-col>
    <el-col :span="2" class="el-col--offset-1em" v-if="expressedInUnit">
      {{ expressedInUnit }}
    </el-col>
  </div>
</template>

<script>
import { get, has, isNil } from 'lodash';

export default {
  name: 'evolution-settings-form-input-simple',
  props: {
    id: {
      required: true,
      default: null,
    },
    code: {
      required: true,
      default: null,
    },
    description: {
      required: true,
      default: null,
    },
    input: {
      required: true,
      default: null,
    },
    value: {
      required: true,
      default: null,
    },
    placeholder: {
      type: String,
      required: false,
      default: '',
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    clearable: {
      type: Boolean,
      required: false,
      default: false,
    },
    validation: {
      type: Object,
      required: false,
      default: null,
    },
    expressedInUnit: {
      type: String,
      required: false,
      default: null,
    },
    dependsOn: {
      required: false,
      default: null,
    },
    calculated: {
      required: false,
      default: false,
    },
    calculatedFrom: {
      required: false,
      default: null,
    },
  },
  data() {
    return {
      isDisabled: this.disabled,
      simple: {
        id: null,
        code: null,
        value: null,
        description: null,
      },
    };
  },
  methods: {
    update(value) {
      this.$emit('set:value', {
        code: this.simple.code,
        data: {
          measurement_setting_type_id: this.simple.id,
          value: Number(value),
        },
      });
    },
    setRule() {
      this.$emit('set:rule', {
        code: this.code,
        validation: this.validation,
        calculated: this.calculated,
      });
    },
  },
  computed: {
    dependent() {
      return !isNil(this.dependsOn) && this.dependsOn !== 'custom';
    },
    willBeCalculated() {
      const formula = get(this.input, 'calculation_meta.formula', '');
      return !isNil(this.dependsOn) && (this.dependsOn !== 'custom' && this.dependsOn !== formula);
    },
  },
  watch: {
    input() {
      const min = has(this.validation, 'min') ? this.validation.min : null;
      this.simple.value = get(this.input, 'value') || min;
      this.update(this.simple.value);
    },
  },
  created() {
    this.setRule();

    this.simple.id = this.id;
    this.simple.code = this.code;
    this.simple.description = this.description;

    const min = has(this.validation, 'min') ? this.validation.min : null;
    this.simple.value = get(this.input, 'value') || min;
    this.update(this.simple.value);
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/professional/persons/participants/participant-evolution/settings/evolution-settings-form-input/cmpt-form-input-simple.vue